const gql = {
  query: `query getCustomerName {
    getCustomerName {
      firstName,
      middleInitial,
      lastName
    }
  }`,
  meta: {
    label: "Get Customer Name",
  },
};

export default gql;
